import { FiArrowLeft, FiRefreshCw, FiShield } from 'react-icons/fi';
import { AuthShell } from '../_Shared/AuthShell';
import { useAuthVerifyCode } from '../../_Hooks/useAuthVerifyCode';
import { AppSeo } from '../../../../../../_CORE/APP/Templates/_UI/Seo/_index';
import { AppButton } from '../../../../../../_CORE/APP/Templates/_UI/Button/_index';
import { FieldInput } from '../../../../../../_CORE/APP/Templates/_UI/Form/_index';

export const AuthVerifyCodeViewMain = () => {
    const { FORM, isLoading, isResending, emailMasked, expiresIn, resend, backToLogin } = useAuthVerifyCode();

    return (
        <>
            <AppSeo title="Verificar acceso | Bailador" description="Verificacion en dos pasos del panel privado." />
            <AuthShell>
                <div className="PBAUTH__card PBAUTH__card--verify">
                    <h1 className="PBAUTH__card_title">Verificación de acceso</h1>
                    <p className="PBAUTH__card_subtitle">
                        Código enviado a <strong>{emailMasked || 'tu correo de seguridad'}</strong>
                        {expiresIn ? <> · vence en {expiresIn}</> : ''}
                    </p>

                    <form className="PBAUTH__form" onSubmit={FORM.onSubmit} autoComplete="off" noValidate>
                        <FieldInput {...FORM.field('code')} type="text" span={2}
                            label="Código de seguridad" placeholder="123456"
                            inputMode="numeric" autoComplete="one-time-code"
                            iconStart={<FiShield />} isDisabled={isLoading} />

                        <div className="PBAUTH__submit_row">
                            <AppButton className="PBAUTH__submit" type="submit" size="lg" isLoading={isLoading}>
                                Verificar y entrar
                            </AppButton>
                        </div>
                    </form>

                    <div className="PBAUTH__verify_actions">
                        <button type="button" onClick={resend} disabled={isResending}>
                            <FiRefreshCw /> {isResending ? 'Reenviando...' : 'Reenviar código'}
                        </button>
                        <button type="button" onClick={backToLogin}><FiArrowLeft /> Volver</button>
                    </div>
                </div>
            </AuthShell>
        </>
    );
};
